//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import basic from "./basic.vue";
import evaluation from "./evaluation.vue";
import attendance from "./attendance.vue";
export default {
  components: {
    basic: basic,
    evaluation: evaluation,
    attendance: attendance
  },
  data: function data() {
    return {
      activeName: "first"
    };
  },
  created: function created() {}
};